"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateUserDetailsCustomAttributes = exports.requestUserDetailsCustomAttributes = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const userDetailsCustomAttributesQuery = (0, graphql_tag_1.default) `
  query UserDetailsCustomAttributes($workspaceId: ID!, $userId: ID!) {
    role(workspace: $workspaceId, user: $userId) {
      customAttributes {
        attributeId
        value
      }
    }
  }
`;
const userDetailsCustomAttributesMutation = (0, graphql_tag_1.default) `
  mutation RoleUpdate($workspaceId: ID!, $userId: ID!, $data: RoleInputData) {
    roleUpdate(workspace: $workspaceId, user: $userId, data: $data) {
      customAttributes {
        attributeId
        value
      }
    }
  }
`;
const requestUserDetailsCustomAttributes = async ({ workspaceId, userId }) => {
    const { data, errors } = await (0, apollo_1.query)(userDetailsCustomAttributesQuery, {
        variables: {
            workspaceId,
            userId,
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.role;
};
exports.requestUserDetailsCustomAttributes = requestUserDetailsCustomAttributes;
const mutateUserDetailsCustomAttributes = async ({ workspaceId, userId, data: _data }) => {
    const { data, errors } = await (0, apollo_1.mutate)(userDetailsCustomAttributesMutation, {
        variables: {
            workspaceId,
            userId,
            data: _data,
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.roleUpdate;
};
exports.mutateUserDetailsCustomAttributes = mutateUserDetailsCustomAttributes;
